<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14 6H8.4C6.15016 6 5.02524 6 4.23664 6.57295C3.98196 6.75799 3.75799 6.98196 3.57295 7.23664C3 8.02524 3 9.15016 3 11.4V12.6C3 14.8498 3 15.9748 3.57295 16.7634C3.75799 17.018 3.98196 17.242 4.23664 17.4271C5.02524 18 6.15016 18 8.4 18H13.6245C14.663 18 15.1822 18 15.6568 17.8366C15.8136 17.7826 15.9657 17.7157 16.1115 17.6366C16.5526 17.3972 16.9035 17.0144 17.6052 16.2489L19.5488 14.1285C20.368 13.2349 20.7777 12.788 20.8568 12.2587C20.8824 12.0872 20.8824 11.9128 20.8568 11.7413C20.7777 11.212 20.368 10.7651 19.5488 9.87147L17.375 7.5"
      stroke="#FFFFFF"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
  </svg>
</template>
